/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Amount1Inputs */

const vi_driverremittance_amount1 = /** @type {(inputs: Driverremittance_Amount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền`)
};

/**

* @param {Driverremittance_Amount1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_amount1 = /** @type {((inputs?: Driverremittance_Amount1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Amount1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_amount1(inputs)
});
export { driverremittance_amount1 as "driverRemittance_amount" }